import React from 'react';
import { useUI } from '../../context/UIContext';
import { Link, useLocation } from 'react-router-dom';
import { FiHome, FiUsers, FiPlusSquare, FiImage, FiUser, FiCamera } from 'react-icons/fi';

import './BottomNav.css';

const BottomNav = () => {
  const location = useLocation();
  const { openCreatePost } = useUI();

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="bottom-nav">
      <Link to="/" className={`bottom-nav-item ${isActive('/') ? 'active' : ''}`}>
        <FiHome />
        <span>Home</span>
      </Link>
      <Link to="/family" className={`bottom-nav-item ${isActive('/family') ? 'active' : ''}`}>
        <FiUsers />
        <span>Family</span>
      </Link>
      <button className="bottom-nav-item create-btn" onClick={openCreatePost}>
        <FiPlusSquare />
        <span>Post</span>
      </button>
      <Link to="/photos" className={`bottom-nav-item ${isActive('/photos') ? 'active' : ''}`}>
        <FiImage />
        <span>Photos</span>
      </Link>
      <Link to="/event-albums" className={`bottom-nav-item ${isActive('/event-albums') ? 'active' : ''}`}>
        <FiCamera />
        <span>Event Photos</span>
      </Link>
    </nav>
  );
};

export default BottomNav;
